// General
import "./body-type-filter-dialog.scss";
import { useEffect, forwardRef } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateBodyTypeFilterDialog } from "../../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog, Slide } from "@mui/material";
// Components
import BodyTypeFilter from "../../../elements/filters/body-type-filter/body-type-filter";

const BodyTypeFilterDialog = () => {
  // Redux variables
  const bodyTypeFilterDialog = useSelector(
    (state) => state.dialog.bodyTypeFilterDialog
  );
  const dispatch = useDispatch();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!bodyTypeFilterDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-BodyTypeFilter-Dialog",
      },
    });
  }, [bodyTypeFilterDialog]);

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateBodyTypeFilterDialog(false));
  };

  return (
    <Dialog
      className="custom-bottom-sheet-dialog"
      fullScreen
      open={bodyTypeFilterDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <BodyTypeFilter />
    </Dialog>
  );
};

export default BodyTypeFilterDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
